import * as React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import {
    Box,
    Button,
    FormControl,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as YUP from "yup";
import axios from 'axios';
import {CheckBox} from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";

const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000000a6',
    boxShadow: 24,
    p: 4,
    borderRadius:'27px'
};



const ProductAndServiceUpdateModal = (props) => {
    const {text,name,price,buy_this,method,product_id,description,btn} = props

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    const formik = useFormik({
        initialValues: {
            name,
            price,
            description,
            buy_this,
            id:product_id

        },

        onSubmit: (values) => {
            // console.log(values);
            method(values,product_id)
            handleClose()
        },
    });


    return (
        <div>
            <Button onClick={handleOpen}>{btn}</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box>
                        <form onSubmit={formik.handleSubmit}>
                            <Box>
                                <Box mb={"2rem"}>
                                    <h1>{text}</h1>
                                </Box>

                                <Grid
                                    container
                                    spacing={1}
                                    display="flex"
                                    justifyContent={"center"}
                                >
                                    <Grid item xs={"auto"}>
                                        {/*    Box 1*/}
                                        <Box
                                            display={"flex"}
                                            justifyContent={"start"}
                                            flexDirection={"row"}
                                        >
                                            <Box>
                                                <Box display={"flex"} justifyContent={"space-between"}>
                                                    <Typography
                                                        variant={"h6"}
                                                        paddingLeft={"16px"}
                                                        paddingTop={"11px"}
                                                        paddingRight={"13px"}
                                                    >
                                                        Name
                                                    </Typography>
                                                    <Box minWidth={"170px"}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                sx={{ width: 170 }}
                                                                {...formik.getFieldProps("name")}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                </Box>

                                                <Box
                                                    display={"flex"}
                                                    marginTop={"15px"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <Typography variant={"h6"} padding={"15px"}>
                                                        Price
                                                    </Typography>
                                                    <Box minWidth={"170px"}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                type={"number"}
                                                                sx={{ width: 170 }}
                                                                {...formik.getFieldProps("price")}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                </Box>

                                                <Box
                                                    display={"flex"}
                                                    marginTop={"15px"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <Typography variant={"h6"} padding={"15px"}>
                                                        Description
                                                    </Typography>
                                                    <Box minWidth={"170px"}>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                type={"text"}
                                                                multiline
                                                                rows={4}
                                                                sx={{ width: 170 }}
                                                                {...formik.getFieldProps("description")}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                </Box>

                                                <Box sx={{display: {sm: "flex", md: "flex"},justifyContent:'center'}}>
                                                    <Typography variant={'h6'} textAlign={"center"} mt={"4.5%"} mx={'10px'}>
                                                        Buy This
                                                    </Typography>
                                                    <Checkbox
                                                        sx={{marginTop:'10px'}}
                                                        {...formik.getFieldProps('buy_this')}
                                                        checked={formik.values.buy_this === 1}
                                                        onChange={(event)=>{
                                                            formik.setFieldValue('buy_this', event.target.checked ? 1 : 0);
                                                        }}
                                                    />

                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={"auto"}>
                                        {/*    Box 2*/}
                                        <Box
                                            display={"flex"}
                                            sx={{ justifyContent: { xs: "start", md: "center" } }}
                                            flexDirection={"row"}
                                        ></Box>
                                    </Grid>

                                    <Grid item xs={"auto"}>
                                        {/*    Box 3*/}
                                        <Box
                                            display={"flex"}
                                            justifyContent={"start"}
                                            flexDirection={"row"}
                                        ></Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box display={"flex"} mt={"25px"} justifyContent={"center"}>
                                <Button type={"submit"}>Save</Button>
                            </Box>
                        </form>
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

export default ProductAndServiceUpdateModal